module.exports = __webpack_public_path__ + "img/fachadaisa2.9ef07a27.png";